/**
 * @override King Living: BaseHeroBannerFragment with CF-04 fields (backgroundColour, textColour, enableScrollEffect, backgroundGradient).
 */

import gql from 'graphql-tag';

export const BaseHeroBannerFragment = gql`
  fragment BaseHeroBannerFragment on HeroBanner {
    __typename
    sys {
      id
    }
    appearance
    backgroundColour
    backgroundGradient
    enableScrollEffect
    headingTitle
    subtitle
    textColour
    title
  }
`;
